import Vue from 'vue'
import Router from 'vue-router'
import { firebase } from '@/firebase.js'
import store from './store/index.js'

import Login from '@/views/Login'
import Invoicing from '@/views/Invoicing'
import InvoiceReceiving from '@/views/InvoiceReceiving'
import Tasks from '@/views/Tasks'
import WeeklyTasks from '@/views/WeeklyTasks'
import MonthlyTasks from '@/views/MonthlyTasks'
import Ordering from '@/views/Ordering'
import Inventory from '@/views/Inventory'
import Guides from '@/views/Guides'
import Settings from '@/views/Settings'
import Reports from '@/views/Reports'
import Dashboard from '@/views/Dashboard'
import Resources from '@/views/Resources'
import Insights from '@/views/Insights'
import Transfers from '@/views/Transfers'
import Waste from '@/views/Waste'
import TaskAudit from '@/views/TaskAudit'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login, //() => import(/* webpackChunkName: "login" */ './views/Login')
      meta: {
        authRequired: false
      }
    },
    {
      path: '*',
      redirect: '/tasks'
    },
    {
      path: '/invoicing',
      name: 'invoicing',
      component: Invoicing,
      meta: {
        authRequired: false
      }
    },
    {
      path: '/invoicing/receive',
      name: 'invoice-receiving',
      component: InvoiceReceiving,
      meta: {
        authRequired: false
      }
    },
    {
      path: '/tasks/weekly',
      name: 'weekly-tasks',
      component: WeeklyTasks,
      meta: {
        authRequired: false
      }
    },
    {
      path: '/tasks/monthly',
      name: 'monthly-tasks',
      component: MonthlyTasks,
      meta: {
        authRequired: false
      }
    },
    {
      path: '/tasks/:shift?',
      name: 'tasks',
      component: Tasks, //() => import(/* webpackChunkName: "tasks" */ './views/Tasks')
      meta: {
        authRequired: false
      }
    },
    {
      path: '/ordering',
      name: 'ordering',
      component: Ordering, // () => import(/* webpackChunkName: "ordering" */ './views/Ordering')
      meta: {
        authRequired: false
      }
    },
    {
      path: '/inventory',
      name: 'inventory',
      component: Inventory, //() => import(/* webpackChunkName: "inventory" */ './views/Inventory'),
      meta: {
        authRequired: true
      }
    },
    {
      path: '/guides/:id?',
      name: 'guides',
      component: Guides, //() => import(/* webpackChunkName: "guides" */ './views/Guides')
      meta: {
        authRequired: false
      }
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings, //() => import(/* webpackChunkName: "settings" */ './views/Settings'),
      meta: {
        authRequired: true
      }
    },
    {
      path: '/reports',
      name: 'reports',
      component: Reports, // () => import(/* webpackChunkName: "settings" */ './views/Reports'),
      meta: {
        authRequired: true
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard, // () => import(/* webpackChunkName: "settings" */ './views/Reports'),
      meta: {
        authRequired: false
      }
    },
    {
      path: '/resources',
      name: 'resources',
      component: Resources, // () => import(/* webpackChunkName: "settings" */ './views/Reports'),
      meta: {
        authRequired: false
      }
    },
    {
      path: '/insights',
      name: 'insights',
      component: Insights, // () => import(/* webpackChunkName: "settings" */ './views/Reports'),
      meta: {
        authRequired: false
      }
    },
    {
      path: '/transfers',
      name: 'transfers',
      component: Transfers,
      meta: {
        authRequired: true
      }
    },
    {
      path: '/waste',
      name: 'waste',
      component: Waste,
      meta: {
        authRequired: true
      }
    },
    {
      path: '/task-audit',
      name: 'task-audit',
      component: TaskAudit,
      meta: {
        authRequired: true,
        requiresAdmin: true
      }
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  let currentUser = firebase.auth().currentUser
  let isManager = store.getters['user/isManager']
  let isAdmin = store.getters['user/isAdmin']
  let requiresAuth = to.matched.some((record) => record.meta.requiresAuth)
  // using replace:true to disable the window.history mode
  //let toPath = { replace: true }

  let requiresAdmin = to.matched.some((record) => record.meta.requiresAdmin)

  if (!currentUser) {
    //requiresAuth &&
    to.path === '/login' ? next() : next({ path: '/login' })
  } else {
    if (to.path === '/login') next({ path: '/dashboard' })
    else if (requiresAuth && !isManager) next(false)
    else if (requiresAdmin && !isAdmin) next(false)
    else next()
  }
})

export default router
